import React, { MouseEventHandler, useMemo, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { Listings } from 'containers/AppContainer/typings';
import {
  CorporealDocument,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { translate } from 'containers/services/translate';
import { StyledJudgementAddPronouncingRecap } from 'containers/common/LegalProceedings/JudgementAdd/Recap/styled-component';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';

import SahamAccordion from 'components/SahamAccordion';
import JudgementAddPronouncingRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/index';
import {
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import { showValidator } from 'containers/common/LegalProceedings/utils';
import { get, isEmpty, isNull } from 'lodash';
import { toBeEdited } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { isMonitoringCourtManager } from 'helpers/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
export interface JudgementAddPronouncingRecapAccordionProps {
  intl: IntlShape;
  listings: Listings;
  judgementAddDocument: JudgementADDDocumentType;
  index: number;
  deleteJudgementAdd?: MouseEventHandler;
  editJudgementAdd?: MouseEventHandler;
  readOnly?: boolean;
  judgementAdd?: IJudgementAdd | {};
  requestMakeJudgementAddDocumentDecision?: Function;
  isManager: boolean;
  resetUploadedDocument: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  document?: CorporealDocument;
  setDocument?: Function;
  docType?: string;
  docId?: string;
  setDocumentId?: Function;
  documentId?: string;
  claimNumber?: string;
  setJudgementAdd?: Function;
  requestUpdateJudgementAddDocument?: Function;
  isSaved?: boolean;
  judiciaryProcessId?: number;
  setDialogOpenFirmReference?: Function;
  isAssignedLawyer?: boolean;
  requestGetJudgementAdd?: Function;
  expertReport?: ExpertReportType;
  judgementOnMerits?: JudgementOnMeritsType;
  handleIsDialogOpen?: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  claimAssignment: any;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  isBasicManagement?: boolean;
  policyInfo: any;
  requestGetDocByDocumentumId: Function;
  setOpenInvoiceFeeNoteUpdateInfoDialog: Function;
  openInvoiceFeeNoteUpdateInfoDialog: boolean;
  setJudgemenAddDocumentToUpdate: Function;
  handleValidateUpdateJudgementAddDocument: Function;
}

const JudgementAddPronouncingRecapAccordion: React.FC<JudgementAddPronouncingRecapAccordionProps> = (
  props,
): JSX.Element => {
  const [expanded, setExpanded] = useState<boolean>(true);
  const handleChangeOnExpand = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    event.stopPropagation();
    setExpanded(expanded);
  };
  const jaddDocumentValidator = showValidator(
    get(props, 'judgementAddDocument.validator', ''),
    props.isManager,
  );
  const jaddValidator =
    showValidator(get(props, 'judgementAdd.validator', ''), props.isManager) &&
    isEmpty(get(props, 'judgementAddDocument.status'));

  const { deleteJudgementAdd, editJudgementAdd } = props;
  const decidedBy = (
    <section className="section">
      <article>
        {translate(messages.judgement, props, { index: props.index + 1 })}
      </article>
      {props.isSaved &&
        (props.isAssignedLawyer || props.isManager) &&
        get(props.judgementAddDocument, 'uploadedBy', '') && (
          <ValidatorRecap
            validator={get(props.judgementAddDocument, 'uploadedBy', '')}
            customTitle={translate(messages.creatorTitleMultiple, props)}
          />
        )}
      {jaddDocumentValidator && (
        <ValidatorRecap
          validator={get(props.judgementAddDocument, 'validator', '')}
        />
      )}
      {jaddValidator && (
        <ValidatorRecap validator={get(props.judgementAdd, 'validator', '')} />
      )}
    </section>
  );
  const isCreator = useMemo(
    () =>
      props.isManager
        ? true
        : isNull(get(props.judgementAddDocument, 'uploadedBy'))
        ? get(props.judgementAdd, 'creator', '')
        : get(props.judgementAddDocument, 'uploadedBy') ===
          currentIntervenantStorage.get()?.preferred_username,
    [
      props.isManager,
      get(props.judgementAdd, 'creator', ''),
      get(props.judgementAddDocument, 'uploadedBy'),
      currentIntervenantStorage.get()?.preferred_username,
    ],
  );
  return (
    <StyledJudgementAddPronouncingRecap>
      <SahamAccordion
        title={decidedBy}
        deleteButtonTitle={
          !isMonitoringCourtManager()
            ? translate(messages.deleteJudgement, props)
            : undefined
        }
        expanded={expanded}
        onChange={handleChangeOnExpand}
        deleteButtonOnClick={deleteJudgementAdd}
        editButtonTitle={
          !isMonitoringCourtManager()
            ? translate(messages.editJudgement, props)
            : undefined
        }
        editButtonOnClick={
          !isMonitoringCourtManager() ? editJudgementAdd : undefined
        }
        accordionDetailsClassName="content-wrapper"
        readOnly={
          ![
            !props.readOnly,
            isCreator &&
              toBeEdited(props.judgementAddDocument, props.isManager),
          ].some(item => item)
        }
      >
        <JudgementAddPronouncingRecap
          judgementAdd={props.judgementAdd}
          judgementAddDocument={props.judgementAddDocument}
          listings={props.listings}
          requestMakeJudgementAddDocumentDecision={
            props.requestMakeJudgementAddDocumentDecision
          }
          isManager={props.isManager}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          document={props.document}
          setDocument={props.setDocument}
          claimNumber={props.claimNumber}
          setJudgementAdd={props.setJudgementAdd}
          requestUpdateJudgementAddDocument={
            props.requestUpdateJudgementAddDocument
          }
          judiciaryProcessId={props.judiciaryProcessId}
          setDialogOpenFirmReference={props.setDialogOpenFirmReference}
          requestGetJudgementAdd={props.requestGetJudgementAdd}
          expertReport={props.expertReport}
          judgementOnMerits={props.judgementOnMerits}
          handleCivilPartyDialog={props.handleIsDialogOpen}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          claimAssignment={props.claimAssignment}
          feeNotes={props.feeNotes}
          setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
          isBasicManagement={props.isBasicManagement}
          policyInfo={props.policyInfo}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          setOpenInvoiceFeeNoteUpdateInfoDialog={
            props.setOpenInvoiceFeeNoteUpdateInfoDialog
          }
          openInvoiceFeeNoteUpdateInfoDialog={
            props.openInvoiceFeeNoteUpdateInfoDialog
          }
          setJudgemenAddDocumentToUpdate={props.setJudgemenAddDocumentToUpdate}
          handleValidateUpdateJudgementAddDocument={
            props.handleValidateUpdateJudgementAddDocument
          }
        />
      </SahamAccordion>
    </StyledJudgementAddPronouncingRecap>
  );
};

export default injectIntl(JudgementAddPronouncingRecapAccordion);
